import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/apps/admin/node_modules/next/dist/client/app-dir/link.js");
